import { checkInRoutes, RoutesViews } from '@gss/router';

export const checkInStepsBinds: RoutesViews<typeof checkInRoutes> = {};
